const AppStatuses = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'    
  };
  
export default AppStatuses;